import React from 'react'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Box, Button, Typography, Paper } from '@mui/material'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'

export const Route = createFileRoute('/_not-found')({
  component: NotFoundPage,
})

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          maxWidth: 480,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box>
          
          <Typography variant="h2" sx={{ fontWeight: 800 }}>
            💧
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            Oops!
          </Typography>
          <Typography variant="body1" color="text.secondary">
            We couldn&apos;t find the page you&apos;re looking for.
          </Typography>
        </Box>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="primary"
          sx={{ alignSelf: 'center', textTransform: 'none', fontWeight: 700 }}
        >
          Back to map
        </Button>
      </Paper>
    </Box>
  )
}
